import { render } from "./App.vue?vue&type=template&id=77878aae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77878aae&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__